export const menu = [
    {
        "title": "\u0422\u0443\u0440\u043d\u0438\u0440\u044b",
        "icon": "aperture",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/dashboard\/tournaments",
                "title": "\u0422\u0443\u0440\u043d\u0438\u0440\u044b BIGPLAY",
                "type": "link"
            },
            {
                "path": "\/dashboard\/promo\/tournaments",
                "title": "\u041f\u0440\u043e\u043c\u043e \u0442\u0443\u0440\u043d\u0438\u0440\u044b",
                "type": "link"
            },
            {
                "path": "/dashboard/tournament-templates",
                "title": "Шаблоны",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u041a\u043e\u043c\u0430\u043d\u0434\u044b",
        "icon": "users",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/teams",
                "title": "\u0420\u0435\u0430\u043b\u044c\u043d\u044b\u0435 \u041a\u043e\u043c\u0430\u043d\u0434\u044b",
                "type": "link"
            },
            {
                "path": "\/teams\/fake",
                "title": "\u0424\u0435\u0439\u043a\u043e\u0432\u044b\u0435 \u041a\u043e\u043c\u0430\u043d\u0434\u044b",
                "type": "link"
            },
            {
                "path": "\/teams\/trashed",
                "title": "\u0423\u0434\u0430\u043b\u0435\u043d\u043d\u044b\u0435 \u041a\u043e\u043c\u0430\u043d\u0434\u044b",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0438",
        "icon": "users",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/dashboard\/users\/real",
                "title": "\u0420\u0435\u0430\u043b\u044c\u043d\u044b\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0438",
                "type": "link"
            },
            {
                "path": "\/dashboard\/users\/fake",
                "title": "\u0424\u0435\u0439\u043a\u043e\u0432\u044b\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0438",
                "type": "link"
            },
            {
                "path": "\/dashboard\/users\/levels",
                "title": "\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0438 \u0441 \u0443\u0440\u043e\u0432\u043d\u0435\u043c",
                "type": "link"
            },
            {
                "path": "\/dashboard\/users\/transfer-logs",
                "title": "\u0422\u0440\u0430\u043d\u0441\u0444\u0435\u0440\u044b",
                "type": "link"
            },
            {
                "path": "\/dashboard\/users\/login-logs",
                "title": "\u0410\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044f",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u0411\u0430\u043d",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/ban\/users",
                "title": "\u0411\u0430\u043d \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
                "type": "link"
            },
            {
                "path": "\/ban\/teams",
                "title": "\u0411\u0430\u043d \u043a\u043e\u043c\u0430\u043d\u0434",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u041e\u0440\u0433\u0430\u043d\u0438\u0437\u0430\u0446\u0438\u0438",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/organizers",
                "title": "\u0421\u043f\u0438\u0441\u043e\u043a \u043e\u0440\u0433\u0430\u043d\u0438\u0437\u0430\u0446\u0438\u0439",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u0418\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442\u044b",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/posts",
                "title": "\u041d\u043e\u0432\u043e\u0441\u0442\u0438",
                "type": "link"
            },
            {
                "path": "\/help",
                "title": "\u041f\u043e\u043c\u043e\u0449\u044c",
                "type": "link"
            },
            {
                "path": "\/main-banner",
                "title": "\u0413\u043b\u0430\u0432\u043d\u044b\u0439 \u0431\u0430\u043d\u043d\u0435\u0440",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u0420\u0435\u0439\u0442\u0438\u043d\u0433 Pubg Mobile",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/rating\/teams",
                "title": "\u041a\u043e\u043c\u0430\u043d\u0434\u044b",
                "type": "link"
            },
            {
                "path": "\/rating\/tournaments",
                "title": "\u0422\u0443\u0440\u043d\u0438\u0440\u043e\u0432 ",
                "type": "link"
            },
            {
                "path": "\/rating\/users",
                "title": "\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
                "type": "link"
            },
            {
                "path": "\/rating\/world-rating",
                "title": "\u041c\u0438\u0440\u043e\u0432\u043e\u0439 \u0440\u0435\u0439\u0442\u0438\u043d\u0433",
                "type": "link"
            },
            {
                "path": "\/rating\/bpl",
                "title": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c BPL \u0441\u0435\u0437\u043e\u043d",
                "type": "link"
            },
            {
                "path": "\/rating\/bpl-season",
                "title": "\u0421\u0435\u0437\u043e\u043d\u043d\u044b\u0439 \u0440\u0435\u0439\u0442\u0438\u043d\u0433",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u0420\u0435\u0439\u0442\u0438\u043d\u0433 Mlbb",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/rating-mlbb\/tournaments",
                "title": "\u0422\u0443\u0440\u043d\u0438\u0440\u044b",
                "type": "link"
            },
            {
                "path": "\/rating-mlbb\/teams",
                "title": "\u041a\u043e\u043c\u0430\u043d\u0434\u044b",
                "type": "link"
            }
        ]
    },
    {
        "title": "Watch",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/watch",
                "title": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u0433\u043b\u0430\u0432\u043d\u044b\u0439 \u0431\u0430\u043d\u043d\u0435\u0440",
                "type": "link"
            },
            {
                "path": "\/watch\/create",
                "title": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c watch",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u0420\u0430\u0441\u0441\u044b\u043b\u043a\u0430",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/newsletter\/create",
                "title": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u0440\u0430\u0441\u0441\u044b\u043b\u043a\u0443",
                "type": "link"
            },
            {
                "path": "\/newsletter\/telegram",
                "title": "Telegram \u0440\u0430\u0441\u0441\u044b\u043b\u043a\u0430",
                "type": "link"
            }
        ]
    },
    {
        "title": "\u041c\u043e\u0434\u0435\u0440\u0430\u0442\u043e\u0440\u044b BIGPLAY",
        "icon": "users",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "\/dashboard\/organizer\/users",
                "title": "\u0412\u0441\u0435 \u043c\u043e\u0434\u0435\u0440\u0430\u0442\u043e\u0440\u044b",
                "type": "link"
            }
        ]
    },
    {
        "title": "Voting",
        "icon": "table",
        "type": "sub",
        "active": false,
        "children": [
            {
                "title": "\u0413\u043e\u043b\u043e\u0441\u043e\u0432\u0430\u043d\u0438\u0435",
                "path": "\/voting",
                "name": "list_votes",
                "component": "ListVotes",
                "type": "link",
                "meta": {
                    "title": "List Votes"
                }
            }
        ]
    },
    {
        "title": "Розыгрыши",
        "icon": "gift",
        "type": "sub",
        "active": false,
        "children": [
            {
                "title": "Список розыгрышей",
                "path": "/giveaways",
                "name": "list_giveaways",
                "component": "ListGiveaways",
                "type": "link",
                "meta": {
                    "title": "List Giveaways"
                }
            }
        ]
    },
    {
        "title": "Тикеты",
        "icon": "message-square",
        "type": "sub",
        "active": false,
        "children": [
            {
                "path": "/tickets/dashboard",
                "name": "tickets_dashboard",
                title: 'Дашборд',
                "component": "TicketsDashboard",
                type: 'link',
                "meta": {
                    "title": "Tickets Dashboard"
                }
            },
            {
                "path": "/tickets/board",
                "name": "tickets_board",
                title: 'Доска Тикетов',
                "component": "TicketsBoard",
                type: 'link',
                "meta": {
                    "title": "Tickets Board"
                }
            },
            {
                "path": "\/tickets\/statuses",
                "name": "tickets_status",
                "component": "TicketStatuses",
                type: 'link',
                title: 'Статусы',
                "meta": {
                    "title": "Tickets Status"
                }
            },
            {
                "path": "\/tickets\/actions",
                "name": "tickets_actions",
                "component": "TicketActions",
                title: 'Действия',
                type: 'link',
                "meta": {
                    "title": "Tickets Actions"
                }
            },
            {
                "path": "\/tickets\/groups",
                "name": "tickets_groups",
                "component": "TicketGroups",
                type: 'link',
                title: 'Группы',
                "meta": {
                    "title": "Tickets Groups"
                }
            },
            {
                "path": "\/tickets\/types",
                "name": "tickets_types",
                "component": "TicketTypes",
                type: 'link',
                title: "Типы",
                "meta": {
                    "title": "Tickets Types"
                }
            },
            {
                "path": "\/tickets\/categories",
                "name": "tickets_categories",
                type: 'link',
                title: 'Категории',
                "component": "TicketCategories",
                "meta": {
                    "title": "Tickets Categories"
                }
            }
        ]
    },
    {
        title: "Трансляция MLBB",
        icon: "tv",
        type: "sub",
        active: false,
        children: [
            {
                path: "/mlbb-broadcast",
                name: "mlbb_broadcast",
                title: "Эфир MLBB",
                component: "MlbbBroadcastPage",
                type: "link",
                meta: { title: "MLBB Broadcast" }
            },
            {
                path: "/mlbb-broadcast/judges",
                name: "mlbb_broadcast_judges",
                title: "Судьи",
                component: "MlbbJudgesPage",
                type: "link",
                meta: { title: "MLBB Broadcast Judges" }
            }
        ]
    },
    {
        title: "AI Чат",
        icon: "cpu",
        type: "sub",
        active: false,
        children: [
            {
                path: "/ai-chat",
                name: "ai_chat",
                title: "Чат",
                component: "AiChatPage",
                type: "link",
                meta: { title: "AI Chat" }
            },
            {
                path: "/ai-chat/business-prompt",
                name: "ai_chat_business_prompt",
                title: "Бизнес-промпт",
                component: "BusinessPromptPage",
                type: "link",
                meta: { title: "AI Business Prompt" }
            }
        ]
    },
    {
        title: "Аналитика",
        icon: "bar-chart-2",
        type: "sub",
        active: false,
        children: [
            {
                path: "/analytics",
                name: "analytics",
                title: "Скорость сайта",
                component: "AnalyticsPage",
                type: "link",
                meta: { title: "Analytics" }
            },
            {
                path: "/analytics/product",
                name: "analytics_product",
                title: "Продукт",
                component: "AnalyticsPage",
                type: "link",
                meta: { title: "Analytics Product" }
            }
        ]
    }
]
